import { api } from './api'

export interface WorkspaceChannel {
  id: number
  name: string
  app_workspace_channel_id: string
  created_at: string | null
}

export interface Workspace {
  workspace_id: number
  workspace_name: string
  app_workspace_id: string
  channels: WorkspaceChannel[]
}

export interface WorkspaceChannelsResponse {
  workspaces: Workspace[]
}

export const workspaceService = {
  async getWorkspaceChannels(organizationId: number): Promise<WorkspaceChannelsResponse> {
    const response = await api.get(`/workspaces/channels/organization/${organizationId}`)
    return response.data
  },

  async deleteChannel(channelId: number, organizationId: number): Promise<void> {
    await api.delete(`/workspaces/channels/${channelId}/organization/${organizationId}`)
  },
}
